import { render } from "./tab_reappro.vue?vue&type=template&id=3ef1497c&scoped=true"
import script from "./tab_reappro.vue?vue&type=script&lang=js"
export * from "./tab_reappro.vue?vue&type=script&lang=js"

import "./tab_reappro.vue?vue&type=style&index=0&id=3ef1497c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef1497c"]])

export default __exports__